import React from "react";
import PropTypes from "prop-types";
import { isLogoPathValid } from "lib/validate";
import ImmutablePropTypes from "react-immutable-proptypes";

import schoolMoneyLogo from "components/assets/images/school_money/school_money-logo--new.svg";
import GenericSchoolLogo from "components/SchoolLogo";

export default class SchoolLogo extends React.Component {

  static propTypes = {
    school: ImmutablePropTypes.shape({
      logoFilePath: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired,
    cssBlockName: PropTypes.string
  }

  getLogoURL = () => {
    const { logoFilePath } = this.props.school.toJS();
    if (logoFilePath === "" || !isLogoPathValid(logoFilePath)) {
      return schoolMoneyLogo;
    }
    return logoFilePath;
  }

  render() {

    const { school, cssBlockName } = this.props;

    return <GenericSchoolLogo logoURL={this.getLogoURL()} schoolName={school.get("name")} cssBlockName={cssBlockName} cssModifier="school_money" />;

  }

}



// WEBPACK FOOTER //
// ./src/components/school_money/SchoolLogo.js